import { ConsoleLogger } from "./ConsoleLogger";
import { SectionLoggerFactory } from "./SectionLoggerFactory";
import { ILoggingSettings } from "./types";

/**
 * Výchozí implementace {@link ILogger}-u.
 * - K červnu 2020 je to {@link ConsoleLogger}. Ale programátor by se na to neměl spoléhat.
 * - Z libovolného důvodu se to může v budoucnu změnit.
 */
const defaultLogger = new ConsoleLogger();

/**
 * Vytvoří továrnu pro loggery výchozího typu. Tato továrana je určena pro tvorbu loggerů na místech, kde není k dispozici DIContainer, nebo
 * kde ještě neproběhla registrace vlastních implementací loggerů. Z toho plyne, že tato továrna **nezohledňuje registrace vlastních implementací loggerů**.
 * Pro loggery používá {@link defaultLogger}.
 *
 * Pro běžné logování v aplikaci se používá:
 * - Továrna získaná z DIContaineru pomocí `DIContainer.instance.create(ISectionLoggerFactory)`.
 * - {@link LazyLoadingSectionLogger} pro reactovou část, nebo místa, která by neměla být přímo závislá na DIContaineru.
 *
 * @param loggingSettings Nastavení úrovní logování.
 */
export const createDefaultSectionLoggerFactory = (loggingSettings: ILoggingSettings) => new SectionLoggerFactory(loggingSettings, () => defaultLogger);
